// Created by PeakXin on 2025/10/29.
import request from '@/utils/request'

export function getToken(data) {
  return request({
    url: '/v1/token/get-token',
    method: 'get',
    params: data
  })
}

export function verifyToken(token) {
  return request({
    url: '/v1/token/verify-token',
    method: 'get',
    params: { token }
  })
}
